import { useState, useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';

const VIDEO_URL = 'https://res.cloudinary.com/dyi1z08og/video/upload/v1773879014/%EC%9A%B0%EB%A6%AC%EC%A7%91_%EC%9D%B4%EC%82%AC_%EC%83%88%EB%B2%BD_t2saht.mp4';

export default function Hero() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative h-screen w-full overflow-hidden">
      <Navbar isScrolled={isScrolled} />

      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={VIDEO_URL}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-4 max-w-4xl mx-auto w-full">
          <span className="inline-block px-3 py-1 mb-4 bg-white/20 border border-white/40 text-white text-xs font-semibold tracking-widest rounded-full backdrop-blur-sm drop-shadow">
            100% 직영 운영
          </span>
          <p className="text-sm md:text-lg mb-3 font-medium tracking-wide text-white/85 drop-shadow-lg">
            수도권(서울·경기·인천)·&nbsp;강원도 철원 이사 전문업체
          </p>
          <h1
            className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black mb-4 drop-shadow-xl leading-tight"
            style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}
          >
            이사는 우리집 익스프레스
          </h1>
          <p className="text-xs md:text-base text-white/80 mb-7 max-w-xl mx-auto leading-relaxed drop-shadow px-2">
            합리적인 가격, 완벽한 포장, 믿을 수 있는 직영팀이 처음부터 끝까지 책임집니다
          </p>
          <a
            href="https://talk.naver.com/profile/wfu3m6i"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-7 py-2.5 border-2 border-white text-white hover:bg-white hover:text-gray-900 transition-all duration-300 text-sm font-semibold tracking-wider whitespace-nowrap cursor-pointer drop-shadow-lg"
          >
            무료 견적 신청 &gt;
          </a>
        </div>
      </div>
    </div>
  );
}
